import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { watchBuild } from "@/lib/freshBuild";

// Anything that throws while rendering lands here with a way back, instead of an empty page.
class Crash extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    const body = { message: String(error?.message || error).slice(0, 1000), stack: String(error?.stack || "").slice(0, 8000),
      component: String(info?.componentStack || "").slice(0, 8000), url: window.location.href.slice(0, 500) };
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/crash`, { method: "POST", credentials: "include", keepalive: true,
      headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).catch(() => {});
  }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    // The first place in the bundle, so a screenshot is enough to find the line through the source map.
    const where = String(error?.stack || "").match(/[\w.-]+\.js:\d+:\d+/)?.[0];
    return (
      <div className="fixed inset-0 grid place-items-center p-6 text-center" role="alert" data-testid="crash">
        <div className="hud-panel max-w-sm rounded-[28px] p-6">
          <h1 className="text-xl font-semibold">Something broke</h1>
          <p className="mt-2 break-words text-sm text-x-mute">{String(error?.message || error)}</p>
          {where && <p className="mt-1 break-all font-mono text-[11px] text-x-mute">{where}</p>}
          <button type="button" onClick={() => window.location.reload()} className="chip-btn mt-5 w-full py-3">Reload</button>
        </div>
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Crash>
      <App />
    </Crash>
  </React.StrictMode>,
);
watchBuild();
